import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

import { OButton } from '@src/shared';
import { TButtonVariant } from '@src/shared/OButton/types';

import styles from './CollapsibleAccordion.module.scss';

interface ICollapsibleAccordionProps {
  isExpanded: boolean;
  onToggle: () => void;
  icon: ReactNode;
  text: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
  buttonVariant?: TButtonVariant;
  buttonOutlined?: boolean;
  canClose?: boolean;
}

const CollapsibleAccordion = ({
  isExpanded,
  onToggle,
  icon,
  text,
  buttonText,
  onButtonClick,
  showButton = false,
  buttonVariant = 'primary',
  buttonOutlined = false,
  canClose = true,
}: ICollapsibleAccordionProps) => {
  return (
    <>
      <div className={styles.accordion}>
        <motion.div
          onClick={onToggle}
          className={cn(styles.iconButton, { [styles.disabled]: !canClose })}
          whileHover={canClose ? { scale: 1.1 } : undefined}
          transition={{ duration: 0.2 }}
        >
          {icon}
        </motion.div>
        <AnimatePresence initial={false}>
          {isExpanded && (
            <motion.div
              className={styles.textWrapper}
              initial={{ maxWidth: 0, opacity: 0 }}
              animate={{ maxWidth: 500, opacity: 1 }}
              exit={{ maxWidth: 0, opacity: 0 }}
              transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
            >
              <span className={styles.text}>{text}</span>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && showButton && buttonText && onButtonClick && (
          <motion.div
            className={styles.buttonWrapper}
            initial={{ maxWidth: 0, opacity: 0 }}
            animate={{ maxWidth: 200, opacity: 1 }}
            exit={{ maxWidth: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          >
            <OButton
              text={buttonText}
              variant={buttonVariant}
              outlined={buttonOutlined}
              size="m-small"
              onClick={onButtonClick}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default CollapsibleAccordion;
